import changeInput from 'root/src/client/logic/form/actions/changeInput'

import clearFormErrors from 'root/src/client/logic/form/actions/clearFormErrors'
import clearButtonErrors from 'root/src/client/logic/form/actions/clearButtonErrors'
import setFormErrors from 'root/src/client/logic/form/actions/setFormErrors'

import validateForm from 'root/src/client/logic/form/util/validateForm'
import getOffset from 'root/src/shared/util/getOffset'
import displaySaveMessage from 'root/src/client/logic/form/util/displaySaveMessage'

export const setInputHof =	(
	validateFormFn,
	changeInputFn,
	clearFormErrorsFn,
	setFormErrorsFn,
	clearButtonErrorsFn,
	// eslint-disable-next-line max-len
) => (value, moduleKey, fieldPath, onExit, element, customPath, clearFormInputs) => (dispatch, getState) => {
	dispatch(
		changeInputFn(moduleKey, fieldPath, value, customPath, clearFormInputs),
	)
	dispatch(clearButtonErrorsFn(moduleKey))
	const state = getState()
	return validateFormFn(moduleKey, state)
		.then(async () => {
			if (onExit) {
				let position
				if (element) {
					position = getOffset(element)
				}
				await dispatch(onExit)
				displaySaveMessage(dispatch, position)
			}
			dispatch(clearFormErrorsFn(moduleKey))
		})
		.catch((errors) => {
			dispatch(setFormErrorsFn(moduleKey, errors))
		})
}

export default setInputHof(
	validateForm,
	changeInput,
	clearFormErrors,
	setFormErrors,
	clearButtonErrors,
)
